"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.theme = void 0;
const extendTheme_1 = require("../extendTheme");
const lifeCycle_1 = require("../lifeCycle");
const danger = 'rgb(217, 83, 79)';
const success = 'rgb(80, 182, 72)';
exports.theme = extendTheme_1.extendTheme(lifeCycle_1.theme, {
    name: 'pan',
    userFriendlyName: 'Pan',
    space: [0, 4, 8, 16, 32, 64, 128],
    breakpoints: ['40em', '52em', '64em', '80em', '100em'],
    fontImports: [],
    fonts: {
        heading: 'sans-serif',
        subheading: 'sans-serif',
        body: 'sans-serif',
        navigation: 'sans-serif',
    },
    shadows: [
        '0 1px 2px rgba(125,125,125,0.05)',
        '0 2px 4px rgba(125,125,125,0.1)',
        '0 3px 8px rgba(125,125,125,0.2)',
        '0 4px 16px rgba(125,125,125,0.4)',
        '0 5px 32px rgba(125,125,125,0.6)',
    ],
    fontSizes: {
        xs: '12px',
        sm: '14px',
        md: '16px',
        lg: '18px',
        xl: '20px',
        '2xl': '24px',
        '3xl': '28px',
        '4xl': '36px',
        '5xl': '48px',
        '6xl': '64px',
    },
    dark: true,
    colors: {
        primary: 'rgb(80, 182, 72)',
        primaryText: '#fff',
        primaryDark: 'rgb(60, 152, 52)',
        danger: danger,
        muted: 'rgb(249, 249, 249)',
        success: success,
        info: 'rgb(70, 120, 200)',
        selected: 'rgb(51, 122, 183)',
        warning: '#FDD835',
        accent: 'rgb(51, 122, 183)',
        online: success,
        accentBackgroundedText: '#fff',
        pageBackground: '#f2f2f2',
        pageText: 'rgb(51, 51, 51)',
        cardBackground: '#fff',
        cardText: 'rgb(51, 51, 51)',
        offline: danger,
        charts: {
            primary: 'rgb(80, 182, 72)',
            min: '#0000ff',
            max: danger,
            neutral: '#bbbbbb',
            intervalShade: '#ddd',
        },
        install: {
            connected: success,
            expired: danger,
            pending: 'rgb(70, 120, 200)',
            planned: '#555',
            skipped: '#fb0',
        },
    },
});
//# sourceMappingURL=index.js.map